import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-movie-2-line" />
              </span>
              <span className="text-lg font-bold text-foreground-950 font-heading">
                桔子<span className="text-primary-600">视频</span>
              </span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注于正版影视资源的在线播放与视频分享，涵盖电影、电视剧、综艺等多类别内容，带来优质视听体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">内容导航</h3>
            <ul className="mt-3 space-y-2 text-sm text-foreground-600">
              <li>
                <Link to="/category/movie" className="transition-colors hover:text-primary-600">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="transition-colors hover:text-primary-600">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="transition-colors hover:text-primary-600">
                  综艺
                </Link>
              </li>
              <li>
                <Link to="/category/documentary" className="transition-colors hover:text-primary-600">
                  纪录片
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">关于平台</h3>
            <ul className="mt-3 space-y-2 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/share-intro" className="transition-colors hover:text-primary-600">
                  视频分享
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-primary-600">
                  搜索发现
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">联系我们</h3>
            <ul className="mt-3 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                  <i className="ri-mail-line text-base" />
                </span>
                support@juzivideo.com
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                  <i className="ri-phone-line text-base" />
                </span>
                400-800-6688
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                  <i className="ri-map-pin-line text-base" />
                </span>
                北京市朝阳区影视产业园
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>© 2026 桔子视频 JuziVideo · 本站为演示平台，影视内容与数据均为示例展示。</p>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-base text-primary-600" />
              正版内容合作
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-customer-service-2-line text-base text-accent-600" />
              7×24 客服
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}